import { useQuery } from '@tanstack/react-query';
import { getStoreManualDayEntry, StoreManualDayEntry } from 'services/auditService';

export function useStoreManualDayEntry(
    storeId: string | null | undefined,
    businessDate: string | null | undefined,
    enabled: boolean = true
) {
    return useQuery<StoreManualDayEntry | null, Error>({
        queryKey: ['store-manual-day-entry', storeId, businessDate],
        queryFn: () => getStoreManualDayEntry(storeId!, businessDate!),
        enabled: enabled && !!storeId && !!businessDate,
    });
}
